






import Vue from 'vue'
import Guess from './Guess.vue'

export default Vue.extend({
  name: 'Answers',
  components: {
    Guess
  },
  computed: {
    guesses () {
      return this.$store.state.guesses
    }
  }
})
